import React from 'react'

function Notice() {
  return (
    <div>
      
    </div>
  )
}

export default Notice
